module.exports = __webpack_public_path__ + "static/media/img2-3.dd8c7bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/biosense/diff/img2-3.png
// module id = 1433
// module chunks = 3